/* eslint-disable no-unused-vars */
/* eslint-disable no-async-promise-executor */
/* eslint-disable eqeqeq */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { uniqueId, get, find, isEmpty, isArray, includes } from 'lodash';
import { fetchAuthSession } from '@aws-amplify/auth';
import { AUTH_KEY_PREFIX } from '@aws-amplify/auth/cognito';
import { MDTApp } from './bootAction.js';
import { bypassNavigationBlock } from './blockNavigation.js';
import constants from '../helpers/constants.js';
import configureStore from '../helpers/configure-store.js';
import { MDTApi } from '../services/mdtapi.js';
import { MDTAnalytics } from '../services/mdtanalytics.js';
import { getUrlParameter } from '../helpers/commonUtils.js';
import MDTNotification from '../components/molecules/mdt-notification/index.js';
import { updateTokens } from '../reducers/cognitoTokensReducer.js';
import {
    getCustomerInfoCall,
    getDefaultCustomer,
    getDownloadHideConfig,
    getFeatureConfiguration,
    getUserDetails,
    getUserInfoCall,
    getUserPermissions,
    getDefaultContract,
    getCountryList,
    fetchAPINotificationPreferencesList,
} from '../services/meService.js';
import { setCountryList } from '../reducers/commonData.js';
import { storageService } from '../helpers/storageUtility.js';

const store = configureStore();
const FORM_ENCODED_CONTENT_TYPE = 'application/x-www-form-urlencoded; charset=UTF-8';
const CLIENT_CREDENTIALS = 'mdtcJs:medtronic';
const refreshInterval = 50;
let refreshToken = null;

// TODO: This adds support for the redirection back to the portal from myorders,
//  we will expect them to send us a valid "access token" 20250224:Alevale
const myOrderToken = getUrlParameter('redirect-token');
if (myOrderToken) {
    refreshToken = myOrderToken;
} else {
    if (
        localStorage[
            Object.keys(localStorage)
                .filter((a) => a.includes(AUTH_KEY_PREFIX))
                .filter((a) => a.includes('refresh'))
        ]
    ) {
        refreshToken =
            localStorage[
                Object.keys(localStorage)
                    .filter((a) => a.includes(AUTH_KEY_PREFIX))
                    .filter((a) => a.includes('refresh'))
            ];

        // NOTE: Not ideal, but there are times where the refreshToken in sessionStorage is "undefined" so preventing here that it happens 20250424:Alevale
    } else if (
        sessionStorage.getItem('apiRefreshToken') &&
        sessionStorage.getItem('apiRefreshToken') !== 'undefined'
    ) {
        refreshToken = sessionStorage.getItem('apiRefreshToken');
    }
}

let accessToken = null;
let refreshTokenTimer = null;
let userInitResolve = false;

const meState = {
    LOGGED_IN: false,
    USER_DETAILS: false,
    HAS_PERMISSIONS: false,
    HAS_CUSTOMERS: false,
    HAS_RESOURCE_RIGHTS: false,
    FETCHING_PERMISSIONS: false,
    FETCHING_RESOURCE_RIGHTS: false,
    LOGIN_ERROR: false,
    APPLY_ONBOARDING: false,
};

export function getCustomerDetailsSuccess(data) {
    return { type: constants.GET_CUSTOMER_DETAILS_SUCCESS, data };
}

export function setDistributorValue(data) {
    return { type: constants.SET_DISTRIBUTOR_VALUE, data };
}

export function meStateUpdate(data) {
    return { type: constants.ME_STATE_UPDATE, data };
}

export function userpermissionsCheck(dispatch, getState, resolve, appId, buId) {
    return async (dispatch, getState) => {
        await dispatch(checkUserPermissions(dispatch, getState, resolve, appId, buId));
    };
}

export function setDefaultCustomer(data) {
    localStorage.setItem(
        'customerISOCode',
        get(data, 'customer.soldTo.address.country.isocode', '')
    );
    return { type: constants.SET_DEFAULT_CUSTOMER, data };
}

export function setDefaultContracts(data) {
    return { type: constants.SET_DEFAULT_CONTRACTS, data };
}

export function setUserType(data) {
    return { type: constants.SET_USER_TYPE, data };
}

export function setSupportedSuppliers(data) {
    return { type: constants.SET_SUPPORTED_SUPPLIERS, payload: data };
}

export function stateUpdate(state) {
    state = state || {};
    return (dispatch) => {
        Object.assign(meState, state);
        dispatch(meStateUpdate(meState));
    };
}

export const preInit = () => {
    return (dispatch) => {
        dispatch(getThemeUpdate());
        getCountryList().then((data) => {
            dispatch(setCountryList(data));
        });
    };
};

function getPreferredCustomer(appId, buId, currentState) {
    // check if a preference exists for that App / BU combination
    const userDetails = currentState.meDetails.user || {};
    // let prefObj = find(currentState.meDetails.customerPreferences || {}, { customerid: userDetails.id, appid: appId, buid: buId });
    const prefObj = find(currentState.meDetails.customerPreferences, {
        userid: userDetails.sub,
        appid: appId,
        buid: buId,
    });
    // if does not exist, let's create it and add it to the preference list
    if (prefObj) {
        return prefObj.customerid;
    }
    return null;
}

function loadDefaultCustomer(dispatch, getState, resolve, appId, buId) {
    return (dispatch) => {
        return getDefaultCustomer()
            .then((data) => {
                const pathVars = MDTApi.getPathvariables();
                const customerId = data && data.customer.id;
                pathVars.customerid = customerId;
                if (customerId) {
                    dispatch(setDefaultCustomer(data));
                    dispatch(setPreferredCustomer(customerId, appId, buId));
                    dispatch(MDTAnalytics.cacheCustomTrackingInfo());
                } else {
                    MDTApp.goto(MDTApp.getSetting('links.portal'));
                }
                return customerId;
            })
            .catch((error) => {
                throw error;
            })
            .then((customerId) => {
                dispatch(defaultContract());
                dispatch(checkResourceRights(appId, buId, resolve));
                return customerId;
            });
    };
}

function getAPINotificationPreferencesList(comHubConfig) {
    return (dispatch) => {
        return fetchAPINotificationPreferencesList()
            .then((res) => {
                let data = res.find((i) => i.code === comHubConfig) || {};

                if (!isEmpty(data)) {
                    data = JSON.parse(data.value || '{}');
                }
                dispatch(setSupportedSuppliers(data));
            })
            .catch((error) => {
                throw error;
            });
    };
}

function defaultContract() {
    return (dispatch) => {
        return getDefaultContract()
            .then((data) => {
                dispatch(setDefaultContracts(data));
            })
            .catch((error) => {
                throw error;
            });
    };
}

export function setPreferredCustomer(customerId, appId, buId, redirectUrl) {
    // init customerPreference array
    return (dispatch, getState) => {
        const customerPreferences = getState().meDetails.customerPreferences || [];
        const user = getState().meDetails.user || {};
        // check that preference not already exists for that App / BU combination
        let prefObj = find(customerPreferences, {
            userid: user.sub,
            appid: appId,
            buid: buId,
        });

        // if does not exist, let's create it and add it to the preference list
        if (!prefObj) {
            prefObj = {
                userid: user.sub,
                appid: appId,
                buid: buId,
                customerid: customerId,
            };

            customerPreferences.push(prefObj);
            dispatch(getCustomerDetailsSuccess(customerPreferences));
        }

        // if it exists, just change the customerId in object ref
        if (prefObj && prefObj.hasOwnProperty('customerid')) {
            prefObj.customerid = customerId;
        }

        // Store new preferences in local storage
        localStorage.setItem('customer', JSON.stringify(customerPreferences));
        if (redirectUrl) {
            MDTApp.goto(redirectUrl);
        }
    };
}

function getUserPermissionsSuccess(data) {
    return { type: constants.USER_PERMISSIONS_SUCCESS, data };
}

function checkUserPermissions(dispatch, getState, resolve, appId, buId) {
    return async (dispatch, getState) => {
        const currentState = getState();
        let customerId = getPreferredCustomer(appId, buId, currentState);
        const fetchCustomer = MDTApp.getSetting('login.fetchCustomer', true);
        const internalUserFetchCustomer = MDTApp.getSetting(
            'login.internalUserFetchCustomer',
            true
        );

        // If no preferred customer can be found, let's load a default one set for the user / bu / app
        if (
            (!fetchCustomer ||
                (currentState.meDetails.user.isinternal === 'True' &&
                    !internalUserFetchCustomer)) &&
            currentState.meDetails.meState.LOGGED_IN
        ) {
            dispatch(checkResourceRights(appId, buId, resolve));
            return;
        }
        if (!customerId && currentState.meDetails.meState.LOGGED_IN) {
            // dispatch(checkResourceRights(appId, buId));
            customerId = await dispatch(
                loadDefaultCustomer(dispatch, getState, resolve, appId, buId)
            );
        }

        dispatch(stateUpdate({ FETCHING_PERMISSIONS: true }));
        const pathVars = MDTApi.getPathvariables();
        pathVars.customerid = customerId;

        if (currentState.meDetails.meState.LOGGED_IN) {
            getUserPermissions(customerId)
                .then(async (data) => {
                    dispatch(getUserPermissionsSuccess(data));
                    dispatch(stateUpdate({ FETCHING_PERMISSIONS: false, HAS_PERMISSIONS: true }));
                    dispatch(setDefaultCustomer(data));
                    await dispatch(
                        getAPINotificationPreferencesList('SupplierList_ComHubConfig_CENT')
                    );
                    dispatch(defaultContract());
                    dispatch(MDTAnalytics.cacheCustomTrackingInfo());
                    dispatch(getFormConfig());
                    if (
                        MDTApp.getSetting('autoCheckPermissions', true) &&
                        MDTApp.getSetting('login.autoCheckRights', false)
                    ) {
                        dispatch(checkResourceRights(appId, buId, resolve));
                    }
                })
                .catch((error) => {
                    throw error;
                });
        }
    };
}

export function featureConfiguration(customerId) {
    return (dispatch, getState) => {
        let territoryId = get(getState(), 'meDetails.customer.territory.id', undefined);
        let countryId = get(
            getState(),
            'meDetails.customer.soldTo.address.country.isocode',
            undefined
        );
        let appid = window.MDTSetting.appid || window.appSettings.appid;
        const applyOnBoard = get(getState(), 'meDetails.meState.APPLY_ONBOARDING', false);

        // NOTE: If the app is territory dependent and there is no customer and no territory defined get
        // the default one. This will be used for user configuration and other generic pages 20220609:Alevale
        if (
            window.MDTSetting.appNeedsTerritory &&
            !territoryId &&
            !customerId &&
            applyOnBoard === false
        ) {
            return getDefaultCustomer()
                .then((res) => {
                    territoryId = get(res, 'customer.territory.id', undefined);
                    countryId = get(res, 'customer.soldTo.address.country.isocode', undefined);
                    appid = window.MDTSetting.appid || window.appSettings.appid;
                    dispatch(setDefaultCustomer(res));
                    return getFeatureConfiguration(territoryId, countryId, appid);
                })
                .then((data) => {
                    dispatch(getAPINotificationPreferencesList('SupplierList_ComHubConfig'));
                    dispatch(saveFeatureConfiguration(data));
                })
                .catch(() => {
                    dispatch(saveFeatureConfiguration({}));
                });
        }

        return getFeatureConfiguration(territoryId, countryId, appid)
            .then((data) => {
                dispatch(saveFeatureConfiguration(data));
            })
            .catch((error) => {
                console.error('An error occurred:', error);
                console.error('trace error:', error.stack);
                dispatch(saveFeatureConfiguration({}));
            });
    };
}

function saveFeatureConfiguration(data) {
    let config = [];
    const configValue = {};
    try {
        config = data.reduce((result, item) => {
            if (!isEmpty(result[item.feature])) {
                console.warn(
                    `${item.feature} configuration is available more than one time in response, please correct the configuration data.`
                );
            }
            configValue[item.feature] = Object.assign(item, { configuration: item.configuration });
            result = MDTApp.mergeDeep(result, configValue);
            return result;
        }, {});
        const defaultCartType = get(config, 'DefaultCartType.configuration.cartType', 'DEFAULT');
        MDTApi.setDefaultPathVar('defaultCartType', defaultCartType);
    } catch (error) {
        console.error('An error occurred while saving feature configuration:', error);
    }
    return { type: constants.FEATURE_CONFIGURATION, config };
}

function getFormConfig() {
    return (dispatch) => {
        getDownloadHideConfig()
            .then((data) => {
                const langArr =
                    !isEmpty(data) && isArray(data.fields)
                        ? data.fields.map((item) => item.id)
                        : [];
                dispatch(setDownloadConfig(langArr));
            })
            .catch((e) => {
                console.error('An error occurred while fetching form configuration:', e);
                dispatch(setDownloadConfig([]));
            });
    };
}

function setDownloadConfig(data) {
    return { type: constants.FORM_CONFIG_HIDE_DOWNLOAD, data };
}

export function getResourceRightsSuccess(data) {
    return { type: constants.USER_RESOURCE_RIGHT, data };
}

export function getResourceRights(apikey) {
    return MDTApi.call(apikey, {
        method: 'GET',
    });
}

export function getRoleAccess(appId, rolePermission) {
    return (dispatch, getState) => {
        const access = getState().AccountDetails.user.access || [];

        return (
            access.length > 0 &&
            !!access.find(
                (app) =>
                    app.appId === appId &&
                    app.roles.find(
                        (role) => role.permissions && role.permissions.includes(rolePermission)
                    )
            )
        );
    };
}

export function checkResourceRights(appId, buId, resolve) {
    return (dispatch, getState) => {
        const currentState = getState();
        const customerId = getPreferredCustomer(appId, buId, currentState);
        let apiKey = 'api.login.resourceRights';

        if (customerId) {
            apiKey = 'api.login.resourceRightsForCustomer';
        }

        dispatch(stateUpdate({ FETCHING_RESOURCE_RIGHTS: true }));
        const pathVars = MDTApi.getPathvariables();
        pathVars.customerid = customerId;
        // apiKey = processPathVariables(MDTApp.getSetting(apiKey), pathVars);
        getResourceRights(apiKey)
            .then((data) => {
                dispatch(getResourceRightsSuccess(data));
                console.log('get resource check');
                dispatch(
                    stateUpdate({ FETCHING_RESOURCE_RIGHTS: false, HAS_RESOURCE_RIGHTS: true })
                );
                resolve && resolve();
            })
            .catch((error) => {
                throw error;
            })
            .then(() => {
                const currentState = getState();
                console.log('currentState');
                console.log(currentState);
            });
    };
}

const initTokenWithCognito = async (sessionObj, dispatch, getState, resolve, fromTimeout) => {
    let authSession;
    try {
        authSession = await fetchAuthSession({ forceRefresh: true });

        const { accessToken, idToken } = authSession.tokens ?? {};

        dispatch(
            setCognitoTokens({
                accessToken: accessToken?.payload,
                idToken: idToken?.payload,
            })
        );

        await new Promise(async (resolve, reject) => {
            try {
                await handleRefreshSuccess(
                    {
                        access_token: accessToken?.toString(),
                        refresh_token:
                            localStorage[
                                Object.keys(localStorage)
                                    .filter((a) => a.includes(AUTH_KEY_PREFIX))
                                    .filter((a) => a.includes('refresh'))
                            ],
                    },
                    dispatch,
                    getState,
                    resolve,
                    fromTimeout
                );
            } catch (error) {
                reject(error);
            }
        });
        dispatch(getCustomerDetailsSuccess(sessionObj.customerPreferencesValue));
        dispatch(setDistributorValue(sessionObj.distributorValue));
        dispatch(MDTApp.authenticate());

        // NOTE: Refresh the accessToken every 5 minutes unless the config says anything else 20250424:Alevale
        refreshTokenTimer = setTimeout(
            async () => {
                initializeToken(dispatch, getState, resolve, fromTimeout);
            },
            1000 * 60 * (MDTApp?.getAwsConfig()?.Auth?.accessTokenTimeout || 5)
        );
    } catch (error) {
        if (error.name === 'InvalidTokenError') {
            // NOTE: We can end up here in 2 cases:
            // 1. When we switch authentication clients (new client auth for the user pool)
            // 2. When the session has expired and is invalid
            // From the error message there is no way to know in which of the 2 states you are at any given time
            // The only "giveaway" is that the cognito library clears the localStorage in case of an expired session
            // and doesn't clean it if the client has changed. Because the tokens don't exist, this will also make the
            // logout function think it's on the normal logout and it'll call the siteminder logout which will fail.
            // So we'll pass a flag to the logout so they can check the case where' in, and then just refresh the page
            // 20250519:Alevale

            localStorage.removeItem('apiToken');
            sessionStorage.removeItem('apiRefreshToken');

            // NOTE: As stated in the comment above, if the session expired, amplify cleans up the tokens,
            // we are testing if we find in the local auth key store the refresh token. If we don't find it
            // we don't need to logout, since the session is clean already, so just refresh the page 20250519:Alevale
            if (
                !Object.keys(localStorage)
                    .filter((a) => a.includes(AUTH_KEY_PREFIX))
                    .filter((a) => a.includes('refresh')).length
            ) {
                // NOTE: Refresh the page after 2 seconds so the user goes to the login and can re-login 20250519:Alevale
                setTimeout(() => {
                    window.location.reload();
                }, 1000 * 2);
                return;
            }
            MDTApp.logout();
            return;
        }
        // NOTE: Any error here is uncharted territory, let's monitor these 20250519:Alevale

        console.error('Error fetching auth session:', error);
        // NOTE: This is a temporary fix, we should be able to handle this error better, although it's a backend error,
        // so IDK what else we could do but wait for lambda to wake up and then retry a minute later 20250424:Alevale
        // Uncaught (in promise) UnexpectedLambdaException: PreTokenGenerationV3_0 invocation failed due to
        // error Socket timeout while invoking Lambda function. 20250424:Alevale

        setTimeout(() => {
            // NOTE: Let's leave it like this, if there's still issues, nuke it all using handleRefreshError(dispatch, getState); 20250425:Alevale
            window.location.reload();
        }, 1000 * 60);
    }
};

export async function initializeToken(dispatch, getState, resolve, fromTimeout) {
    const sessionObj = initializeFromStorage();

    // NOTE: If the user was already previously logged in, so check if there's a refreshToken on the localStore 20250929:Alevale
    if (
        localStorage[
            Object.keys(localStorage)
                .filter((a) => a.includes(AUTH_KEY_PREFIX))
                .filter((a) => a.includes('refresh'))
        ]
    ) {
        await initTokenWithCognito(sessionObj, dispatch, getState, resolve, fromTimeout);
        return resolve();
    }
    // NOTE: This are the pages that a user can go to without being logged in, so bypass all 20240621:Alevale
    if (MDTApp.whitelistedUrl(getState().location)) {
        return resolve();
    }
    // NOTE: This will save the links you want to navigate to after clicking on a hyperlink,
    // that way you'll navigate there after login (or so I assume) 20250129:Alevale
    if (window.MDTSetting.appid !== window.MDTSetting.authAppId) {
        dispatch(bypassNavigationBlock(true));
        sessionStorage.setItem('depthURL', window.location.href);
        MDTApp.goto(MDTApp.getSetting('links.login'));
        // NOTE: This is in place to do the redirect to the right page for landing links See feature S-98849 20220822:Alevale
    } else if (!window.location.href.includes(MDTApp.getSetting('links.login'))) {
        dispatch(bypassNavigationBlock(true));
        sessionStorage.setItem('depthURL', window.location.href);
        MDTApp.goto(MDTApp.getSetting('links.login'));
    } else {
        return resolve();
    }
}

export async function handleRefreshSuccess(response, dispatch, getState, resolve, fromTimeout) {
    
    setTokens(response.access_token);
    const authSession = await fetchAuthSession();
    const decodedToken = authSession.tokens?.accessToken?.payload || {};
    const applyOnBoarding = decodedToken.ApplyOnBoarding === 'true';
    // NOTE: This applyOnboarding is legacy and should be refactored 20250707:Alevale
    dispatch(stateUpdate({ LOGGED_IN: true, APPLY_ONBOARDING: applyOnBoarding }));
    if (!applyOnBoarding) {
        await getUserInfo(dispatch, getState, resolve, fromTimeout);
    }
    window.refreshTokenFlag = true;
    if (resolve) {
        resolve();
    }
    return true;
}

export function removeSessionFilters() {
    storageService.session.remove('FILTER_KEYS');
}

function setTokens(accessTokenStorage) {
    if (accessTokenStorage) {
        accessToken = accessTokenStorage;
        localStorage.setItem('apiToken', accessTokenStorage);
    }
}

function initializeFromStorage() {
    // grab existing state from local storage
    const customer = localStorage.getItem('customer');
    let distributor = localStorage.getItem('distributor');
    // restore the me stores' state
    setTokens(localStorage.getItem('apiToken'));
    const customerPreferences = customer ? JSON.parse(customer) : null;
    distributor = distributor ? JSON.parse(distributor) : null;

    return {
        customerPreferencesValue: customerPreferences,
        distributorValue: distributor,
    };
}

let notificationRoot = null;
async function getUserInfo(dispatch, getState, resolve, fromTimeout) {
    // NOTE: It feels like there's no need to call the user over and over again from the token refresh call
    // if there were to be because this function has side effects let's try to look for data from the application
    // state and pull the data from there to save the user calls from the BE 20230530:Alevale
    if (fromTimeout) {
        return;
    }

    return getUserInfoCall()
        .then(async (response) => {
            window.showloaderFirstTime = true;

            // NOTE: If there's no response, the user exists in the external IdP but DOES NOT exist in CONNECT,
            // so redirect to Request access page so they can request access and be handled by CC 20250429:Alevale
            if (!response) {
                // NOTE: Even after refreshing the RequestAccess page, it keeps redirecting to the same URL. This will prevent this unnecessary redirect: varalr2
                if (!window.location.href.includes('requestAccess')) {
                    dispatch({ type: 'REQUESTACCESS' });
                }
                resolve('REQUESTACCESS');
                return;
            }

            // NOTE: Handling Role changes 20230530:Alevale
            if (
                response.isRolesCountMax === 'true' &&
                sessionStorage.getItem('isRolesCountMax') != 'true' &&
                !!Object.keys(window.t).length
            ) {
                const msg = window.t('countMaxContent');
                const props = {
                    contents: [msg],
                    defaultOpen: true,
                    toggle: function () {
                        sessionStorage.setItem('isRolesCountMax', 'true');
                    },
                    notifyType: 'error',
                    title: window.t('countMaxTitle'),
                    key: uniqueId('id_'),
                };
                const elementName = 'msgNotify';
                let element = document.getElementById(elementName);
                if (!element) {
                    element = document.createElement('div');
                    element.setAttribute('id', 'msgNotify');
                    document.body.appendChild(element);
                }
                if (!notificationRoot) {
                    notificationRoot = ReactDOM.createRoot(document.getElementById(elementName));
                }
                // TODO: Refactor this, add <MDTNotification /> to the
                //  skeleton and write here to redux just if it should
                //  be shown or not  20231027:Alevale
                notificationRoot.render(<MDTNotification {...props} />);
            }

            await dispatch(stateUpdate({ USER_DETAILS: true }));

            // NOTE: Dealing with culture changes 20230525:Alevale
            let { culture } = response;
            const cachedCulture = localStorage.getItem('I18N_LANGUAGE_CMS');
            culture = culture ? culture.replace('_', '-') : 'en';
            const hyphenizedCulture = culture;
            localStorage.setItem('I18N_LANGUAGE', culture);
            updateHtmlLang(hyphenizedCulture);
            culture = culture.replace('-', '_'); // we need to ensure the locale we request is an underscore -- this matches how the locales are stored in CMS
            localStorage.setItem('I18N_LANGUAGE_CMS', culture);
            if (culture !== cachedCulture && window.next18) {
                window.next18.changeLanguage(culture);
            }
            dispatch(updateHyphenizedCulture(hyphenizedCulture));

            // NOTE: Saving the user info in the store 20230525:Alevale
            await dispatch(userInfoSucess(response));

            !userInitResolve && resolve && resolve(getState);
            userInitResolve = true;
            // NOTE: This updates the user in analytics with whatever changes have happen, move this logic somewhere else 20230525:Alevale
            getUserDetails()
                .then((userResponse) => {
                    dispatch(storeUserDetails(userResponse));
                    dispatch(MDTAnalytics.cacheUser(MDTApp.getDeviceType()));
                })
                .catch((error) => {
                    throw error;
                });
            const authSession = await fetchAuthSession();
            const decodedAccessToken = authSession.tokens?.accessToken?.payload || {};
            if (!decodedAccessToken) {
                console.error('No access token found after refresh');
                return;
            }
            dispatch(setUserType(decodedAccessToken.isinternal));
        })
        .catch((error) => {
            console.error('An error occurred while fetching user info:', error);
            throw error;
        });
}
function updateHtmlLang(lang) {
    if (!!lang) {
        document.documentElement.setAttribute('lang', lang.toUpperCase()); // Update user selected lang in HTML tag
        // Checking _satellite variable is available on DOM or not
        if (typeof _satellite !== 'undefined' && typeof _satellite.track === 'function') {
            _satellite?.track('OneTrust');
        }
    }
}

function updateHyphenizedCulture(data) {
    return { type: constants.UPDATE_HYPHENIZED_CULTURE, data };
}
function updateUserCulture(data) {
    return { type: constants.UPDATE_LANGUAGE, data };
}
export function userInfoSucess(data) {
    return { type: constants.USER_INFO_SUCCESS, data };
}

export function setLanguage(data) {
    return { type: constants.SET_LANGUAGE, data };
}

export function userInfoSucessLanguageUpdate(data) {
    return (dispatch) => {
        dispatch(updateUserCulture(data));
        const hyphenizedCulture = data ? data.replace('_', '-') : 'en';
        updateHtmlLang(hyphenizedCulture);
        dispatch(updateHyphenizedCulture(hyphenizedCulture));
    };
}

export function storeUserDetails(data) {
    return { type: constants.ACCOUNT_USER_DETAILS_UPDATE, data };
}

export function customerInfoSucess(data) {
    return { type: constants.CUSTOMER_INFO_SUCCESS, data };
}

export function getThemeUpdate() {
    return (dispatch) => {
        // Restricting the update of Theme from localStorage Since Themes can be different in each app
        // let theme = localStorage.getItem("theme") || "";
        dispatch(themeUpdateOnStore());
    };
}
export function themeUpdate(data) {
    return (dispatch) => {
        // Restricting the update of Theme to localStorage Since Themes can be different in each app
        // localStorage.setItem("theme", data);
        dispatch(themeUpdateOnStore(data));
    };
}

export function themeUpdateOnStore(data) {
    return { type: constants.APPLICATION_THEME, data };
}

export function getCustomers() {
    return (dispatch, getState) => {
        const currentState = getState();
        if (
            currentState.meDetails.isInternal &&
            currentState.meDetails.isInternal.toLowerCase() === 'true' &&
            window.MDTSetting.appid === constants.GCDMS
        ) {
            return false;
        }
        getCustomerInfoCall()
            .then((response) => {
                dispatch(stateUpdate({ HAS_CUSTOMERS: true, LOGGED_IN: true }));
                dispatch(customerInfoSucess(response));
            })
            .catch((error) => {
                throw error;
                // to do logout
            });
    };
}

export const setCognitoTokens = ({ accessToken, idToken }) => {
    return (dispatch) => {
        dispatch(
            updateTokens({
                accessToken,
                idToken,
            })
        );
    };
};

export function setSubmissionDetails({ submissionId = '' }) {
    return {
        type: constants.SET_SUBMISSION_DETAILS,
        payload: submissionId,
    };
}
